import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { ITranslateProps, translate } from '../../mixins/translate';
import { fetchJson } from '../../store/fetch';
import { IRouterProps } from '../../utils/IRouterProps';

interface IInspectionStandardsListProps extends ITranslateProps, IRouterProps {
    dispatch: (prop: any) => void;
    location: any;
}

interface IInspectionStandard {
    id: string;
    name: string;
    inspectionType: string;
}

interface IInspectionStandardsListState {
    isLoading: boolean;
    items: IInspectionStandard[];
}

function mapStateToProps() {
    return {};
}

class InspectionStandardsList extends React.Component<IInspectionStandardsListProps, IInspectionStandardsListState> {
    constructor(props: IInspectionStandardsListProps) {
        super(props);

        this.state = {
            isLoading: false,
            items: [],
        };
    }

    public override async componentDidMount() {
        await this.load();
    }

    public override render() {
        return (
            <div>
                <header id="topbar" className="ph10">
                    <div className="topbar-left">
                        <ol className="breadcrumb">
                            <li className="crumb-active">
                                <span className="fa fa-cogs pr10"></span>
                                <a href="#">{this.props.t('common.inspectionCompositionStandard')}</a>
                            </li>
                            <li className="crumb-trail">
                                <Link to={'/settings/objecttypes/'}>{this.props.t('common.objectTypes')}</Link>
                            </li>
                        </ol>
                    </div>
                </header>
                <section id="content" className="table-layout animated fadeIn">
                    <div className="tray tray-center">
                        <div className="admin-form theme-primary mw800 center-block">
                            <div className="panel">
                                <div className="panel-body pn">
                                    <div className="table-responsive">
                                        <table className="table table-hover fs13">
                                            <thead>
                                                <tr className="bg-light">
                                                    <th className="">{this.props.t('common.name')}</th>
                                                    <th className="">{this.props.t('common.type')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.items &&
                                                    this.state.items.map((item) => (
                                                        <tr key={item.id}>
                                                            <td
                                                                className="text-left"
                                                                onClick={(e: any) => this.rowClicked(e, item.id, item.inspectionType)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {item.name}
                                                            </td>
                                                            <td
                                                                className="text-left"
                                                                onClick={(e: any) => this.rowClicked(e, item.id, item.inspectionType)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {item.inspectionType}
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    private rowClicked(e: any, id: string, inspectionType: string) {
        e.preventDefault();
        this.props.navigate(`/settings/objecttypes/inspectionstandards/${id}/editobjecttemplate?inspectiontype=${inspectionType}`);
    }

    // private async handleChange(value: any, stateKey: string) {
    //     const newState = {} as any;
    //     newState[stateKey] = value;
    //     await this.setState(newState);
    // }

    private async load() {
        const url = `/api/inspectionStandards?objectTypeId=${this.props.match.params.id}`;
        this.setState({ isLoading: true });
        const result = await fetchJson(url, 'GET');
        this.setState({ items: result.json, isLoading: false });
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(connect(mapStateToProps, undefined, undefined, { forwardRef: true })(InspectionStandardsList as any) as any);
